const { useState } = require('react');

const internals = {};

exports.useChatProfileDisclosure = ({ viewerId, schoolId, peerId }) => {

    const key = viewerId && schoolId && peerId ? `chat-profile:${schoolId}:${viewerId}:${peerId}` : null;
    const [choice, setChoice] = useState(null);
    const collapsed = choice?.key === key ? choice.collapsed : internals.read(key);

    const setCollapsed = (value) => {

        if (!key) { return; }
        setChoice({ key, collapsed: value });
        try { window.localStorage.setItem(key, value ? 'closed' : 'open'); }
        catch { /* Keep the choice in this mounted chat when storage is unavailable. */ }
    };

    return { collapsed, setCollapsed };
};

internals.read = (key) => {

    try { return !!key && window.localStorage.getItem(key) === 'closed'; }
    catch { return false; }
};
